import { mySqlQueryListDemo2Repo } from "../repo/mySqlQueryListRepo";
import { useMySqlQueryListRuntime } from "./useMySqlQueryListRuntime";

const mySqlQueryListDemo2QueryRootKey = ["demo", "mysql-query-list-demo2"] as const;

/** 封装 Demo2 列表页运行时，避免页面层直接消费 repo 内部实现。 */
export function useMySqlQueryListDemo2Runtime() {
  return useMySqlQueryListRuntime({
    queryRootKey: mySqlQueryListDemo2QueryRootKey,
    fetchList: mySqlQueryListDemo2Repo.fetchList,
    createRecord: mySqlQueryListDemo2Repo.createRecord,
    updateRecord: mySqlQueryListDemo2Repo.updateRecord,
    deleteRecord: mySqlQueryListDemo2Repo.deleteRecord,
  });
}
